import {
  IModuloSubmoduloForm,
  IModuloSubmoduloRegistro,
} from '../../modules/types/ModuloSisaf';
import httpClient from '../httpClient';

const API_BASE = '/api/modulossubmodulos';

export const getAllModuloSubmodulos = async (): Promise<
  IModuloSubmoduloRegistro[]
> => {
  try {
    const response = await httpClient.get(API_BASE);

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error('Erro ao obter lista de submódulos: ' + error.message);
  }
};

export const getModuloSubmodulosByModuloId = async (
  moduloId: number,
): Promise<IModuloSubmoduloRegistro[]> => {
  try {
    const response = await httpClient.get(`${API_BASE}/modulo/${moduloId}`);

    return Array.isArray(response.data?.registros)
      ? response.data.registros
      : [];
  } catch (error: any) {
    throw new Error(
      'Erro ao obter submódulos do módulo selecionado: ' + error.message,
    );
  }
};

export const getModuloSubmoduloById = async (
  id: string | number,
): Promise<IModuloSubmoduloRegistro> => {
  try {
    const response = await httpClient.get(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao obter Submódulo: ' + error.message);
  }
};

export const handleCreateModuloSubmodulo = async (
  form: IModuloSubmoduloForm,
): Promise<any> => {
  try {
    const response = await httpClient.post(API_BASE, form);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao criar Submódulo: ' + error.message);
  }
};

export const handleUpdateModuloSubmodulo = async (
  form: IModuloSubmoduloForm,
): Promise<any> => {
  try {
    const response = await httpClient.patch(`${API_BASE}/${form.id}`, form);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao atualizar Submódulo: ' + error.message);
  }
};

export const handleDeleteModuloSubmodulo = async (
  id: string | number,
): Promise<any> => {
  try {
    const response = await httpClient.delete(`${API_BASE}/${id}`);
    return response.data;
  } catch (error: any) {
    throw new Error('Erro ao excluir Submódulo: ' + error.message);
  }
};
